import React, { useEffect, useState } from 'react';
import icSend from '../../../assets/svg/steps/card/fa_send-o.svg';
import icBtnCancel from '../../../assets/svg/btn/ic-cancel.svg';
import icBtnSend from '../../../assets/svg/btn/ic-send.svg';
import CustomBtn from '../../../components/UIBTN/CustomBtn';
import axiosClient from '../../../../axios-client';
import { ToastContainer, toast } from 'react-toastify';
import plusIcon from '../../../assets/svg/plus-ic.svg';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FormControlLabel, FormGroup, Switch } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const Confirm = ({ getBroadcastId, isDraft, isDone, getContactLengh, backStep }) => {
  const [isSuccess, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msgCredit, setMsgCredit] = useState();
  const [confirmMsgCredit, setMsgConfirmCredit] = useState();
  const [isCancel, setCanccel] = useState(false);
  const [msgSucess, setMsgSucccess] = useState();
  const [scheduleDateTime, setScheduleDateTime] = useState('');
  const [ isSchedule, setIsSchedule ] = useState(false);


  const handleReload = () => {
    window.location.reload();
  };

  const handleCancel = () => {
    setCanccel(true);
    setSuccess(true);
    isDraft(true);
  };

  const errMsg = (msg) => {
    toast.error(`${msg}`, {
      position: 'bottom-center',
      autoClose: 1900000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light',
    });
  };

  const getCurrentDateTime = () => {
      const now = new Date();
      const dateTime = new Date(now.getTime() + 60 * 60 * 2000);
      return dateTime.toISOString().slice(0, 16);
  };


  const handleDateTimeChange = (event) => {
    setScheduleDateTime(event.target.value);
  };

  const confimSend = () => {
    setLoading(true);
    const delayedToParam = isSchedule ? `&delayed_to=${scheduleDateTime}` : '';
  
    axiosClient.post(`/broadcast/send?broadcast_id=${getBroadcastId}${delayedToParam}`)
      .then(({ data }) => {
        if (data.success) {
          setMsgSucccess(data.message);
          setLoading(false);
          setSuccess(true);
          isDone(true);
        }
      })
      .catch(err => {
        const response = err.response;
        errMsg(response.data.message);
        setLoading(false);
      });
  };
  

  useEffect(() => {
    fetchData();
  }, []);

  const updateCreditState = (data) => {
    const globalCredit = data.data;

    const msgCost = globalCredit.data.custom_credit.message_credit == null ? globalCredit.message_credit : globalCredit.data.custom_credit.message_credit;
    const confirmMsg = globalCredit.data.custom_credit.confirmation_credit == null ? globalCredit.confirmation_credit : globalCredit.data.custom_credit.confirmation_credit;

    setMsgCredit(msgCost);
    setMsgConfirmCredit(confirmMsg);
  };

  const fetchData = () => {
    Promise.all([axiosClient.get('/app-settings'), axiosClient.get('/user')])
      .then(([appSettingsData, userData]) => {
        const combinedData = {
          data: {
            ...appSettingsData.data.data,
            ...userData.data,
          },
        };

        updateCreditState(combinedData);
      })
      .catch((error) => {
        console.error("An error occurred while fetching data:", error);
      });
  };


  const switchChange = (event) => {
    const oneHourLater = getCurrentDateTime();
    setScheduleDateTime(oneHourLater);
    setIsSchedule(event.target.checked);
  };

  return (
    <div className='w-100'>
      <ToastContainer />
      <div className='row justify-content-center align-items-center'>
        <div className='col-md-10 text-center'>
          <img className='my-3' src={icSend} alt='' srcSet='' />
          <h1 className='text-center title my-4'>You are about to send a WhatsApp Broadcast to </h1>
          <div className='row justify-content-center align-items-center'>
            <div className='mb-4 d-flex justify-content-center align-items-center'>
              <CustomBtn
                classBtn={'px-1 btn-primary d-flex justify-content-start align-items-center'}
                classIcon={'d-none'}
                className={'pe-3 active text-center'}
                title={`${getContactLengh} contacts`}
              />
            </div>
            <div className={`${!msgSucess ? 'd-none' : 'd-block'} col-md-6 alert alert-success`} role="alert">
              {msgSucess}
            </div>
            {isCancel ? (
              <div className='mb-4 justify-content-center align-items-center'>
                <p className='text-warning'>You don't have enough credits in your balance to send your broadcast.</p>
                <p>Your broadcast is now in <span className='fw-bolder text-draft'>Drafts</span>.</p>
                <p>Please recharge your balance now.</p>
              </div>
            ) : (
                <>
                  { !isSuccess && (
                    <div className='mb-4 d-flex align-items-center justify-content-center'>
                    <FormControlLabel
                    className='m-auto'
                    control={<Switch checked={isSchedule} onChange={switchChange} />}
                    label={
                      <>
                        Schedule broadcast for later
                        <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip-info'>Enable this option to set a specific time for your broadcast to be sent later.</Tooltip>}>
                          <InfoIcon className='ms-3' />
                        </OverlayTrigger>
                      </>
                    }
                    />
                    </div>
                  )}
                {!isSuccess && isSchedule && (
                  <div className='mb-4'>
                    <div className="col-md-3 mb-1 mx-auto">
                      <input
                          className="form-control rounded-pill"
                          type="datetime-local"
                          value={scheduleDateTime}
                          onChange={handleDateTimeChange}
                          min={getCurrentDateTime()}
                          placeholder="Select date and time"
                          // step="60"
                      />
                    </div>
                  </div>
                )}
                <div className='mb-4 d-flex justify-content-center align-items-center'>
                  <div role='button' onClick={loading ? confimSend : isSuccess ? () => { } : confimSend} className={`d-flex justify-content-center align-items-center d-flex align-items-center left-btn mx-2 my-2`}>
                    <span className={`btn-primary d-flex justify-content-start align-items-center py-1 text-start px-1 rounded-pill mx-1`}>
                      <div className='d-flex align-items-center'>
                        <span className={`ps-3 pe-2`}>
                          {loading ? (
                            <span>Sending...</span>
                          ) : !isSuccess ? (
                            <span>Send broadcast</span>
                          ) : (
                            <span>Done</span>
                          )}
                        </span>
                        <img src={icBtnSend} />
                      </div>
                    </span>
                  </div>
                  {!isSuccess ?
                    <div role='button' onClick={handleCancel} className={`bg-c-danger btn-primary d-flex justify-content-start align-items-center`}>
                      <span className={`d-flex justify-content-start align-items-center py-1 text-start px-1 rounded-pill mx-1`}>
                        <div className='d-flex align-items-center'>
                          <span className={`ps-3 pe-2 text-white`}>Cancel</span>
                          <img src={icBtnCancel} />
                        </div>
                      </span>
                    </div> : <div role='button' onClick={handleReload} className={`bg-brodcast nav-link py-1 text-start px-1 rounded-pill mx-1`}>
                    <div className='d-flex align-items-center'>
                  <img width='38' height='38' src={plusIcon} />
                  <span class='px-2'>Click to create a new broadcast</span>
                </div>
              </div>}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Confirm;
